import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  // #handleCartAdd = () => {
  //   if (this.hasAttribute('auto-open')) {
  //     this.showDialog();
  //   }
  // };
  #handleCartAdd = async () => {
  console.log('CartAddEvent triggered');
  if (this.hasAttribute('auto-open')) {
    this.showDialog();
  }

  try {
    // Fetch latest cart info
    const response = await fetch('/?section_id=cart-drawer');
    const text = await response.text();
    const html = new DOMParser().parseFromString(text, 'text/html');

    // Try all possible drawer element names Atelier might use
    const newDrawer =
      html.querySelector('cart-drawer-component') ||
      html.querySelector('cart-drawer') ||
      html.querySelector('#CartDrawer') ||
      html.querySelector('[data-cart-drawer]');

    if (newDrawer) {
      console.log('Drawer HTML found:', newDrawer);
      this.innerHTML = newDrawer.innerHTML;
    } else {
      console.warn('No matching drawer HTML found');
    }

    // Force update item count
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    const countEl = document.querySelector('[data-cart-count], .cart-count');
    if (countEl) countEl.textContent = cart.item_count;
  } catch (err) {
    console.error('Cart drawer refresh failed:', err);
  }
};




  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}



// Ensure PageFly can update the cart instantly
window.themeCartDrawer = {
  forceUpdateCartStatus: function() {
    try {
      // Check if the cart drawer component exists
      const cartDrawer = document.querySelector('cart-drawer-component');
      if (!cartDrawer) return;

      // Force re-render cart items
      const cartItemsComponent = cartDrawer.querySelector('cart-items-component');
      if (!cartItemsComponent) return;

      // Fetch updated cart via Shopify AJAX API
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          // Update cart bubble count
          const bubbleCount = document.querySelector('.cart-bubble__text-count');
          if (bubbleCount) {
            bubbleCount.textContent = cart.item_count;
            bubbleCount.classList.toggle('hidden', cart.item_count === 0);
          }

          // Update cart items list
          const cartItemsContainer = cartItemsComponent.querySelector('.cart-drawer__items');
          if (cartItemsContainer) {
            // Render updated cart items using Shopify section endpoint
            fetch('/?section_id=cart-drawer')
              .then(res => res.text())
              .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newItems = doc.querySelector('.cart-drawer__items');
                if (newItems) cartItemsContainer.innerHTML = newItems.innerHTML;
              });
          }
        })
        .catch(err => console.error('Error updating cart drawer:', err));
    } catch (e) {
      console.error('forceUpdateCartStatus error:', e);
    }
  }
};

// Optional: Listen to Shopify's add-to-cart event and auto-refresh
document.addEventListener('cart:refresh', () => {
  window.themeCartDrawer.forceUpdateCartStatus();
});


// Ensure global object exists for PageFly
window.themeCartDrawer = window.themeCartDrawer || {};

window.themeCartDrawer.forceUpdateCartStatus = function() {
  // Fetch latest cart
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Update cart bubble
      const bubbleCount = document.querySelector('.cart-bubble__text-count');
      if (bubbleCount) {
        bubbleCount.textContent = cart.item_count;
        bubbleCount.classList.toggle('hidden', cart.item_count === 0);
      }

      // Update cart items in drawer
      const cartItemsContainer = document.querySelector('.cart-drawer__items');
      if (cartItemsContainer) {
        fetch('/?section_id=cart-drawer')
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newItems = doc.querySelector('.cart-drawer__items');
            if (newItems) cartItemsContainer.innerHTML = newItems.innerHTML;
          });
      }
    })
    .catch(e => console.error('Cart update failed:', e));
};

// Ensure global object exists
window.themeCartDrawer = window.themeCartDrawer || {};

window.themeCartDrawer.forceUpdateCartStatus = function() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      // Update cart bubble
      const bubbleCount = document.querySelector('.cart-bubble__text-count');
      if (bubbleCount) {
        bubbleCount.textContent = cart.item_count;
        bubbleCount.classList.toggle('hidden', cart.item_count === 0);
      }

      // Update cart drawer items manually
      const cartItemsContainer = document.querySelector('.cart-drawer__items');
      if (cartItemsContainer) {
        // Clear existing items
        cartItemsContainer.innerHTML = '';

        cart.items.forEach(item => {
          const li = document.createElement('div');
          li.className = 'cart-item';
          li.innerHTML = `
            <div class="cart-item__image">
              <img src="${item.image}" alt="${item.title}" />
            </div>
            <div class="cart-item__details">
              <span class="cart-item__title">${item.title}</span>
              <span class="cart-item__quantity">Qty: ${item.quantity}</span>
              <span class="cart-item__price">${(item.price/100).toFixed(2)} $</span>
            </div>
          `;
          cartItemsContainer.appendChild(li);
        });
      }
    })
    .catch(e => console.error('Cart update failed:', e));
};

/**
 * Instant Cart Drawer Update for PageFly + Theme
 * ----------------------------------------------
 * This ensures that the cart drawer updates immediately
 * when adding a product via PageFly AJAX.
 */

(function() {
  // Check if PageFly AJAX function exists
  if (window._pf_ajaxCartUpdate) {
    const originalPfAjaxCartUpdate = window._pf_ajaxCartUpdate;

    window._pf_ajaxCartUpdate = function(...args) {
      // Call the original PageFly AJAX cart update
      originalPfAjaxCartUpdate.apply(this, args);

      // After a short delay, force the theme cart drawer to update
      setTimeout(() => {
        if (window.themeCartDrawer && typeof window.themeCartDrawer.forceUpdateCartStatus === 'function') {
          window.themeCartDrawer.forceUpdateCartStatus();
        }

        // Update cart bubble counts if needed
        const cartBubble = document.querySelector('.cart-bubble__text-count');
        if (cartBubble && window.Shopify && Shopify.cart) {
          cartBubble.textContent = Shopify.cart.item_count;
          cartBubble.classList.remove('hidden');
        }
      }, 50); // 50ms delay ensures PageFly AJAX has updated cart data
    };
  }

  // Optional: fallback for normal Shopify AJAX adds
  document.addEventListener('cart:updated', function(event) {
    if (window.themeCartDrawer && typeof window.themeCartDrawer.forceUpdateCartStatus === 'function') {
      window.themeCartDrawer.forceUpdateCartStatus();
    }
  });
})();

